import { maskitoTimeOptionsGenerator, maskitoWithPlaceholder } from '@maskito/kit';

const TIME_PLACEHOLDER = 'hh:mm';

export const timeOptions = maskitoTimeOptionsGenerator({
  mode: 'HH:MM',
});

const {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  plugins,
  ...placeholderOptions
} = maskitoWithPlaceholder(TIME_PLACEHOLDER, true);

export const timeMask = {
  ...timeOptions,
  plugins: plugins.concat(timeOptions.plugins || []),
  preprocessors: [...placeholderOptions.preprocessors, ...timeOptions.preprocessors],
  postprocessors: [...timeOptions.postprocessors, ...placeholderOptions.postprocessors],
};
